module.exports = __webpack_public_path__ + "img/expovina_06(1).01bce7e7.jpg";